import { _js } from '@ifixit/utils/localize';
import { TiptapButton } from '../TiptapButton';
import { faIndent } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEditorContext, useEditorSelector } from '../../editor_context';

export const IndentButton = () => {
   const { editor } = useEditorContext();
   const state = useEditorSelector(editor => ({
      isDisabled: !editor.can().sinkListItem('listItem'),
   }));

   if (!state) {
      return null;
   }

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().sinkListItem('listItem').run()}
         isDisabled={state.isDisabled}
         icon={<FontAwesomeIcon icon={faIndent} />}
         title={_js('Increase indent')}
         overrideShortcut={'tab'}
      />
   );
};
